import React from 'react';

type StatsCardProps = {
    title: string;
    value: string;
    trend: string;
};

export function StatsCard({ title, value, trend }: StatsCardProps) {
    const isPositive = trend.startsWith('+');

    return (
        <div className="card stats-card">
            <h3>{title}</h3>
            <div className="stats-value">
                <span className="value">{value}</span>
                <span className={`trend ${isPositive ? 'positive' : 'negative'}`}>
                    {trend}
                </span>
            </div>
        </div>
    );
}